/**
 * Markdown日志工具
 * 用于记录Markdown完整性检查的相关日志
 */

import { LogDebugFunction } from './markdownTypes';
import { shouldLog } from './logConfig';

/**
 * 记录处理信息
 */
export const logProcessingInfo = (
  remainingText: string, 
  analyzedText: string, 
  startIdx: number
): void => {
  if (!shouldLog('debug')) return;
  
  // 显示前30个字符，避免日志过长
  const remainingPreview = remainingText.substring(0, 30);
  const analyzedPreview = analyzedText.substring(Math.max(0, analyzedText.length - 30));
  
  console.log('Markdown分析:', {
    剩余文本前30字符: remainingPreview + (remainingText.length > 30 ? '...' : ''),
    已分析文本末尾30字符: analyzedPreview,
    当前位置: startIdx
  });
};

/**
 * 创建调试日志工具
 */
export const createDebugLogger = (
  remainingText: string,
  analyzedText: string,
  charsToShow: number,
  startIdx: number
): LogDebugFunction => {
  return (
    ruleName: string, 
    additionalChars: number
  ): number => {
    if (shouldLog('info')) {
      console.log(`[${ruleName}] 匹配成功:`, {
        原计划显示字符数: charsToShow,
        需要额外显示字符数: additionalChars,
        总显示字符数: charsToShow + additionalChars,
        匹配位置: startIdx
      });
    }
    return additionalChars;
  };
};

/**
 * 记录详细的匹配信息
 */
export const logMatchDetails = (
  ruleName: string,
  match: RegExpMatchArray,
  additionalInfo?: Record<string, any>
): void => {
  if (!shouldLog('verbose')) return;
  
  const matchPreview = match[0].substring(0, 50);
  console.log(`[${ruleName}] 匹配详情:`, {
    匹配文本: matchPreview + (match[0].length > 50 ? '...' : ''),
    捕获组: match.slice(1).map(group => group || '无'),
    总长度: match[0].length,
    ...additionalInfo
  });
}; 